module.exports = __webpack_public_path__ + "static/media/16UNODC25.ed46122a.jpg";